<div class="component-pricelist-container">
  <div class="component-pricelist-header">
    <h4>
      {{ formatMessage("publisherConfiguration.componentPricelist.title") }}
    </h4>
  </div>

  <!-- File Upload Section -->
  <div class="upload-section" style="margin-bottom: 30px">
    <div class="widget-container d-flex flex-grow flex-column">
      <div
        id="component-dropzone-external"
        class="d-flex flex-grow"
        style="font-size: 14px; min-height: 200px"
        [ngClass]="
          isDropZoneActive
            ? ['dx-theme-accent-as-border-color', 'dropzone-active']
            : ['dx-theme-border-color']
        "
      >
        <div
          class="
            d-flex
            flex-column flex-grow
            dropzone-text
            justify-content-center
            align-items-center
            text-center
          "
        >
          <app-alert
            *ngIf="successAlertMessage"
            type="success"
            [message]="successAlertMessage"
            icon="material-icons mdi-success"
            style="margin-bottom: 30px"
          ></app-alert>

          <span *ngIf="!isUploading">{{
            formatMessage(
              "publisherConfiguration.componentPricelist.upload.dragAndDrop"
            )
          }}</span>
          <span *ngIf="!isUploading">{{
            formatMessage(
              "publisherConfiguration.componentPricelist.upload.fileChooser"
            )
          }}</span>

          <span
            *ngIf="invalidFileMessage"
            class="error-message"
            style="margin-top: 20px"
            >{{ invalidFileMessage }}</span
          >

          <!-- Detailed validation error display -->
          <div *ngIf="validationError" class="validation-error-details">
            <h6>
              <i class="fas fa-exclamation-triangle"></i>
              Validation Error Details
            </h6>
            <div class="error-details">
              <div><strong>Error:</strong> {{ validationError.error }}</div>
              <div *ngIf="validationError.row">
                <strong>Row:</strong> {{ validationError.row }}
              </div>
              <div *ngIf="validationError.column">
                <strong>Column:</strong> {{ validationError.column }}
              </div>
              <div *ngIf="validationError.invalidValue">
                <strong>Invalid Value:</strong>
                <code>{{ validationError.invalidValue }}</code>
              </div>
              <div *ngIf="validationError.validationRule">
                <strong>Rule:</strong> {{ validationError.validationRule }}
              </div>
            </div>
          </div>

          <dx-progress-bar
            class="upload-progress"
            width="30%"
            [min]="0"
            [max]="100"
            [showStatus]="false"
            [visible]="progressVisible"
            [value]="progressValue"
          ></dx-progress-bar>

          <app-alert
            *ngIf="!hasNetworkConnection && !invalidFileMessage"
            type="error"
            icon="dx-icon-warning"
            [message]="formatMessage('upload.noNetwork')"
            style="margin-top: 30px"
          ></app-alert>
        </div>
      </div>

      <dx-file-uploader
        #componentFileUploader
        dialogTrigger="#component-dropzone-external"
        dropZone="#component-dropzone-external"
        [readOnly]="isUploading"
        [multiple]="false"
        [allowedFileExtensions]="['.xlsx']"
        uploadMode="useButtons"
        uploadMethod="PUT"
        name="file"
        [visible]="false"
        [uploadHeaders]="{
          'Content-Type':
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }"
        (onDropZoneEnter)="onDropZoneEnter($event)"
        (onDropZoneLeave)="onDropZoneLeave($event)"
        (onValueChanged)="onSelectedFileChanged()"
        (onProgress)="onProgress($event)"
        (onUploadStarted)="onUploadStarted($event)"
        (onUploadError)="onUploadError($event)"
        (click)="onDropZoneClick($event)"
      ></dx-file-uploader>
    </div>
  </div>

  <!-- No Data Message -->
  <div
    class="no-data-section"
    *ngIf="publisherId && componentPriceData.length === 0"
  >
    <div class="alert alert-info">
      <i class="fas fa-info-circle" style="margin-right: 8px"></i>
      {{ formatMessage("publisherConfiguration.componentPricelist.noData") }}
    </div>
  </div>

  <!-- Data Grid Section -->
  <div class="data-grid-section" *ngIf="componentPriceData.length > 0">
    <h5>
      {{
        formatMessage("publisherConfiguration.componentPricelist.data.title")
      }}
    </h5>
    <dx-data-grid
      [dataSource]="componentPriceData"
      [showBorders]="true"
      [remoteOperations]="false"
      [allowColumnReordering]="true"
      [allowColumnResizing]="true"
      [columnAutoWidth]="true"
      [hoverStateEnabled]="true"
      keyExpr="width"
    >
      <dxo-paging [pageSize]="15"></dxo-paging>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[10, 15, 20]"
        [showInfo]="true"
      ></dxo-pager>
      <dxo-sorting mode="multiple"></dxo-sorting>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-header-filter [visible]="true"></dxo-header-filter>

      <dxi-column
        dataField="width"
        [caption]="
          formatMessage(
            'publisherConfiguration.componentPricelist.columns.width'
          )
        "
        dataType="number"
      ></dxi-column>

      <dxi-column
        dataField="length"
        [caption]="
          formatMessage(
            'publisherConfiguration.componentPricelist.columns.length'
          )
        "
        dataType="number"
      ></dxi-column>

      <dxi-column
        dataField="quantity"
        [caption]="
          formatMessage(
            'publisherConfiguration.componentPricelist.columns.quantity'
          )
        "
        dataType="number"
      ></dxi-column>

      <dxi-column
        dataField="component"
        [caption]="
          formatMessage(
            'publisherConfiguration.componentPricelist.columns.component'
          )
        "
      ></dxi-column>

      <dxi-column
        dataField="part"
        [caption]="
          formatMessage(
            'publisherConfiguration.componentPricelist.columns.part'
          )
        "
      ></dxi-column>

      <dxi-column
        dataField="type"
        [caption]="
          formatMessage(
            'publisherConfiguration.componentPricelist.columns.type'
          )
        "
      ></dxi-column>

      <dxi-column
        dataField="pages"
        [caption]="
          formatMessage(
            'publisherConfiguration.componentPricelist.columns.pages'
          )
        "
        dataType="number"
        format="decimal"
      ></dxi-column>

      <dxi-column
        dataField="color"
        [caption]="
          formatMessage(
            'publisherConfiguration.componentPricelist.columns.color'
          )
        "
      ></dxi-column>

      <dxi-column
        dataField="finishingType"
        [caption]="
          formatMessage(
            'publisherConfiguration.componentPricelist.columns.finishingType'
          )
        "
      ></dxi-column>

      <dxi-column
        dataField="specialEffects"
        [caption]="
          formatMessage(
            'publisherConfiguration.componentPricelist.columns.specialEffects'
          )
        "
      ></dxi-column>

      <dxi-column
        dataField="plates"
        [caption]="
          formatMessage(
            'publisherConfiguration.componentPricelist.columns.plates'
          )
        "
        dataType="number"
        format="decimal"
      ></dxi-column>

      <dxi-column
        dataField="mr"
        [caption]="
          formatMessage('publisherConfiguration.componentPricelist.columns.mr')
        "
        dataType="number"
        format="decimal"
      ></dxi-column>

      <dxi-column
        dataField="run"
        [caption]="
          formatMessage('publisherConfiguration.componentPricelist.columns.run')
        "
        dataType="number"
        format="decimal"
      ></dxi-column>
    </dx-data-grid>
  </div>
</div>
